import "./common.scss";
import "./FollowButton.scss";

export const FollowButton = (props: {
  onClick: () => void;
}): JSX.Element => {
  return (
    <button
      className="rg-button follow small"
      onClick={props.onClick}
    >Follow</button>
  );
};
